const currentHost = window.location.hostname;

document.querySelectorAll('a[href]').forEach(link => {
	try {
		const url = new URL(link.href, window.location.origin);

		if (url.hostname !== currentHost) {
			if (link.target !== '_blank') {
				link.setAttribute('target', '_blank');
			}

			const ariaLabel = link.getAttribute('aria-label') || '';

			link.setAttribute('aria-label', ariaLabel ? ariaLabel + ' (Opens in new window.)' : 'Opens in new window.');
		}
	} catch (e) {
		// Ignore invalid URLs.
	}
});
